/**
 * Constant numerical values used across the application.
 */
export const EXAM_CONFIG = {
  DURATION_SECONDS: 30 * 60, // 30 minutes
  FULLSCREEN_GRACE_PERIOD: 30, // seconds to re-enter fullscreen
  MOUSE_LEAVE_LIMIT_MS: 30000, // 30 seconds before auto-submit
  CLIPBOARD_CLEAR_INTERVAL_MS: 5000,

  // Thresholds for triggers
  FACE_MISSING_TRIGGER_MS: 4000,
  POSITION_WRONG_TRIGGER_MS: 3000,
  OBJECT_DETECTION_COOLDOWN_MS: 5000,
  MOBILE_SCREENSHOT_OVERLAY_MS: 1500,

  // Violation thresholds
  MAX_TAB_SWITCHES: 3,
  MAX_FACE_WARNINGS: 3,
  MAX_POSITION_WARNINGS: 3,
  MAX_OBJECT_WARNINGS: 2,
  MAX_SHORTCUT_VIOLATIONS: 2,

  // Capture intervals
  SCREEN_CAPTURE_INTERVAL_MS: 10000,
  CAMERA_CAPTURE_INTERVAL_MS: 20000,
  MALPRACTICE_CAPTURE_INTERVAL_MS: 5000,
};

/**
 * Constant user-facing notification and error strings.
 */
export const EXAM_MESSAGES = {
  AUTO_SUBMIT_SCREEN_STOP: "EXAM AUTO-SUBMITTED: Screen sharing was stopped.",
  AUTO_SUBMIT_FULLSCREEN:
    "EXAM AUTO-SUBMITTED: You did not retrieve fullscreen mode within 30 seconds.",
  AUTO_SUBMIT_TAB_SWITCH:
    "EXAM AUTO-SUBMITTED: You have switched tabs too many times.",
  AUTO_SUBMIT_FACE_NOT_DETECTED:
    "EXAM AUTO-SUBMITTED: Your face was not detected in the camera frame too many times.",
  AUTO_SUBMIT_POSITION_WRONG:
    "EXAM AUTO-SUBMITTED: Improper head/eye position detected too many times.",
  AUTO_SUBMIT_MOUSE_LEFT:
    "EXAM AUTO-SUBMITTED: Your cursor/focus was outside the exam window for more than 30 seconds.",
  AUTO_SUBMIT_FORBIDDEN_SHORTCUT:
    "EXAM AUTO-SUBMITTED: Forbidden shortcut/screenshot detected multiple times.",

  ALERT_PRINT_PROHIBITED: "Printing is strictly prohibited during the exam.",
  ALERT_MULTI_FACE:
    "SECURITY WARNING: More than one face detected! Please ensure you are alone during the exam.",
  SCREEN_SHARE_REQUIREMENT:
    'You MUST share your "Entire Screen" for the exam. Windows or chrome tabs are not allowed.',

  WARNING_TAB_SWITCH: (count: number) =>
    `WARNING: Tab switching is prohibited. Warning ${count} of 2. Exam will auto-submit on the 3rd violation.`,
  AUTO_SUBMIT_OBJECT_DETECTED: (objects: string) =>
    `EXAM AUTO-SUBMITTED: Restricted object(s) detected (${objects}).`,
};
